"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@emotion/core");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Box_1 = require("./Box");
const dividerTheme = styled_tools_1.theme('Divider');
const HRBox = Box_1.Box.withComponent('hr');
exports.Divider = styled_1.default(HRBox) `
  border-color: currentColor;
  border-style: solid;
  opacity: 0.2;
  ${styled_tools_1.ifProp('vertical', core_1.css `
      margin: 0 1em;
      min-height: 100%;
      width: 0;
      border-width: 0 0 0 1px;
    `, core_1.css `
      margin: 1em 0;
      height: 0;
      border-width: 1px 0 0 0;
    `)};
  ${dividerTheme};
`;

//# sourceMappingURL=Divider.js.map
